type Props = {
  name: string;
};

export const OrganizationTag = ({ name }: Props) => (
  <span className="inline-block max-w-[80px] truncate text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-primary text-white">
    {name}
  </span>
);
